
import React from 'react';
import { MessageSquare } from 'lucide-react';
import { useLanguage } from '@/context/language-context';

const EmptyConversationState: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center">
      <MessageSquare className="w-16 h-16 text-muted-foreground/40 mb-4" />
      <h2 className="text-xl font-semibold mb-2">{t('Select a conversation')}</h2>
      <p className="text-muted-foreground max-w-md">
        {t('common.choose_conversation')}
      </p>
    </div>
  );
};

export default EmptyConversationState;
